var blockBundles;

try {
  blockBundles = {
    revelation_assassin: {
      header: {
        header: {
          html: require("../../revelation_assassin/header/header.html.twig"),
          scss: require("../../revelation_assassin/header/header.scss"),
          js: require("../../revelation_assassin/header/header.js"),
          dir: "revelation_assassin/header/header",
        },
      },
      content: {
        update: {
          html: require("../../revelation_assassin/update/update.html.twig"),
          scss: require("../../revelation_assassin/update/update.scss"),
          js: require("../../revelation_assassin/update/update.js"),
          dir: "revelation_assassin/update/update",
        },
        loading: {
          html: require("../../revelation_assassin/loading/loading.html.twig"),
          scss: require("../../revelation_assassin/loading/loading.scss"),
          js: require("../../revelation_assassin/loading/loading.js"),
          dir: "revelation_assassin/loading/loading",
        },
      },
      footer: {
        footer: {
          html: require("../../revelation_assassin/footer/footer.html.twig"),
          scss: require("../../revelation_assassin/footer/footer.scss"),
          js: require("../../revelation_assassin/footer/footer.js"),
          dir: "revelation_assassin/footer/footer",
        },
      },
      float: {
        float_right: {
          html: require("../../revelation_assassin/float_right/float_right.html.twig"),
          scss: require("../../revelation_assassin/float_right/float_right.scss"),
          js: require("../../revelation_assassin/float_right/float_right.js"),
          dir: "revelation_assassin/float_right/float_right",
        },
        float_top: {
          html: require("../../revelation_assassin/float_top/float_top.html.twig"),
          scss: require("../../revelation_assassin/float_top/float_top.scss"),
          js: require("../../revelation_assassin/float_top/float_top.js"),
          dir: "revelation_assassin/float_top/float_top",
        },
      },
    },
  };
} catch (error) {
  console.log(error);
}

export default blockBundles;
